import script from "./sdkBill.vue?vue&type=script&setup=true&lang=js"
export * from "./sdkBill.vue?vue&type=script&setup=true&lang=js"

import "./sdkBill.vue?vue&type=style&index=0&id=a5d86f76&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5d86f76"]])

export default __exports__